// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StripeInfoPopup_content_container__HD5gT {
  padding: 0 40px 40px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.StripeInfoPopup_info_container__gOWpW {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}
.StripeInfoPopup_info_icon__1oogC {
  width: 70px !important;
  height: 80px !important;
  color: var(--color-theme-blue);
}

.StripeInfoPopup_info_icon_text__aCumM {
  color: var(--color-theme-blue);
  font-weight: bold;
}

.StripeInfoPopup_text_container__hOrWC {
  text-align: center;
}

.StripeInfoPopup_confirm_btn__wjkP3 {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
  margin-top: 30px !important;
}

.StripeInfoPopup_confirm_btn__wjkP3 a {
  text-decoration: none;
  color: var(--color-theme-blue);
}

.StripeInfoPopup_confirm_btn__wjkP3:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.StripeInfoPopup_confirm_btn__wjkP3:hover a {
  color: var(--color-theme-white) !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/StripeInfoPopup/StripeInfoPopup.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".content_container {\n  padding: 0 40px 40px 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.info_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.info_icon {\n  width: 70px !important;\n  height: 80px !important;\n  color: var(--color-theme-blue);\n}\n\n.info_icon_text {\n  color: var(--color-theme-blue);\n  font-weight: bold;\n}\n\n.text_container {\n  text-align: center;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n  margin-top: 30px !important;\n}\n\n.confirm_btn a {\n  text-decoration: none;\n  color: var(--color-theme-blue);\n}\n\n.confirm_btn:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.confirm_btn:hover a {\n  color: var(--color-theme-white) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `StripeInfoPopup_content_container__HD5gT`,
	"info_container": `StripeInfoPopup_info_container__gOWpW`,
	"info_icon": `StripeInfoPopup_info_icon__1oogC`,
	"info_icon_text": `StripeInfoPopup_info_icon_text__aCumM`,
	"text_container": `StripeInfoPopup_text_container__hOrWC`,
	"confirm_btn": `StripeInfoPopup_confirm_btn__wjkP3`
};
export default ___CSS_LOADER_EXPORT___;
